<template>
    <calculation-container>
        <calculation-steps/>
        <h2 class="calculator__header">Vyberte si z nabízených řešení</h2>
        <calculation-construction-list v-if="projects.length"/>
    </calculation-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import CalculationContainer from '../../CalculationContainer';
import CalculationSteps from '../steps/Steps';
import CalculationConstructionList from './ConstructionList'
import calculationMixin from '../mixins/calculation.mixin';

export default {
    name:       'CalculationConstructionSelectContainer',
    mixins:     [calculationMixin],
    components: {
        CalculationConstructionList,
        CalculationSteps,
        CalculationContainer
    },
    mounted() {
        const { projectSlug } = this.$route.params;
        this.setProjectSlug(projectSlug);
        this.fetchProjects();
        this.remarketingDataLayer(projectSlug);
    },
    computed:   {
        ...mapGetters('calculation', ['projects'])
    },
    methods:    {
        ...mapActions('calculation', ['fetchProjects', 'setProjectSlug']),
        remarketingDataLayer(projectSlug) {
            dataLayer.push({
                'event':     'calculator_step_1',
                'step':      1,
                'section':   projectSlug,
                'ecommerce': {
                    'checkout': {
                        'actionField': { 'step': 1, 'option': projectSlug }
                    }
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/calculation/calculator/construction/ConstructionSelectContainer.vue